function _typeof(obj) {
	"@babel/helpers - typeof";
	if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
		_typeof = function _typeof(obj) {
			return typeof obj;
		};
	} else {
		_typeof = function _typeof(obj) {
			return obj &&
				typeof Symbol === "function" &&
				obj.constructor === Symbol &&
				obj !== Symbol.prototype
				? "symbol"
				: typeof obj;
		};
	}
	return _typeof(obj);
}

/**
 * LINE 35 WAS UPDATE.
 * It use `window` instead of `this` to make reference to window
 */
!(function (t, e) {
	(typeof exports === "undefined" ? "undefined" : _typeof(exports)) ===
		"object" &&
	(typeof module === "undefined" ? "undefined" : _typeof(module)) === "object"
		? (module.exports = e())
		: typeof define === "function" && define.amd
		? define([], e)
		: (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ===
			"object"
		? (exports.HttpAdapter = e())
		: (t.HttpAdapter = e());
})(window, function () {
	return (function (t) {
		function e(n) {
			if (r[n]) return r[n].exports;
			var i = (r[n] = {
				exports: {},
				id: n,
				loaded: !1,
			});
			return t[n].call(i.exports, i, i.exports, e), (i.loaded = !0), i.exports;
		}

		var r = {};
		return (e.m = t), (e.c = r), (e.p = ""), e(0);
	})([
		function (t, e, r) {
			"use strict";

			function n(t) {
				return t && t.__esModule
					? t
					: {
							default: t,
						};
			}

			function i(t, e) {
				if (!(t instanceof e))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(e, "__esModule", {
				value: !0,
			});

			var s = (function () {
				function t(t, e) {
					for (var _r = 0; _r < e.length; _r++) {
						var _n = e[_r];
						(_n.enumerable = _n.enumerable || !1),
							(_n.configurable = !0),
							"value" in _n && (_n.writable = !0),
							Object.defineProperty(t, _n.key, _n);
					}
				}

				return function (e, r, n) {
					return r && t(e.prototype, r), n && t(e, n), e;
				};
			})();

			var o = r(1);
			var a = n(o);

			var u = (function () {
				function t(e) {
					if ((i(this, t), !e.url))
						throw new Error("No HTTP endpoint supplied the HTTP Provider!");
					(this.config = e),
						this.setFlushPeriod(e.flush_period),
						(this.name = "http"),
						(this.errorCount = 0),
						(this.eventQueue = []),
						this.setEventTimeout(),
						e.end_retry && typeof e.end_retry === "boolean"
							? (this.end_retry = e.end_retry)
							: (this.end_retry = !1);
				}

				return (
					s(t, [
						{
							key: "setFlushPeriod",
							value: function value(t) {
								void 0 === t || NaN === t
									? (this.FLUSH_PERIOD = 5e3)
									: (this.FLUSH_PERIOD = t),
									(this.async = this.FLUSH_PERIOD > 0);
							},
						},
						{
							key: "setEventTimeout",
							value: function value() {
								var t = this;
								this.errorCount > 4 &&
									!this.end_retry &&
									this.setFlushPeriod(15e3),
									this.async &&
										setTimeout(function () {
											t.flushQueue();
										}, this.FLUSH_PERIOD);
							},
						},
						{
							key: "flush",
							value: function value() {
								this.flushQueue();
							},
						},
						{
							key: "track",
							value: function value(t, e) {
								var r = this;
								var n = JSON.parse(JSON.stringify(t));
								this.processEvent(n),
									(e[t["event-id"] + "-http"] = new Promise(function (i) {
										r.eventQueue.push({
											event: n,
											callback: function callback() {
												i(), delete e[t["event-id"] + "-http"];
											},
										}),
											r.async || r.flushQueue();
									}));
							},
						},
						{
							key: "processEvent",
							value: function value(t) {
								if (t.metadata)
									for (var _e = 0; _e < t.metadata.length; _e++) {
										t.metadata[_e].key.indexOf("ga_") >= 0 &&
											delete t.metadata[_e];
									}
								delete t.tmpMetaData;
							},
						},
						{
							key: "flushQueue",
							value: function value() {
								var t = this;
								if (this.eventQueue.length === 0)
									return void this.setEventTimeout();
								var e = this.eventQueue;
								this.eventQueue = [];

								for (var r = [], n = 0; n < e.length; n++) {
									r.push(e[n].event);
								}

								var i = a.default.post(this.config.url);
								if (this.config.headers)
									for (var _s in this.config.headers) {
										i.set(_s, this.config.headers[_s]);
									}
								i.send(r)
									.withCredentials()
									.end(function (r, n) {
										var i = !0;
										var s = !1;
										var o = void 0;

										try {
											for (
												var a, u = e[Symbol.iterator]();
												!(i = (a = u.next()).done);
												i = !0
											) {
												var h = a.value;
												h.callback();
											}
										} catch (c) {
											(s = !0), (o = c);
										} finally {
											try {
												!i && u.return && u.return();
											} finally {
												if (s) throw o;
											}
										}

										if (r) {
											t.errorCount++, (t.eventQueue = e.concat(t.eventQueue));
											var l = "";
											if (
												((l =
													"Server-side error with POST: " +
													t.config.url +
													"\n" +
													e.length +
													" events failed to send. TRAAC will continue to retry on next tick."),
												t.errorCount >= 3 && t.end_retry)
											)
												throw new Error(
													"After 3 consecutive errors in sending; ending retry loop. Latest error:\n" +
														r
												);
											t.async ||
												setTimeout(function () {
													t.flushQueue();
												}, 2e3);
										} else
											(t.errorCount = 0),
												t.setFlushPeriod(t.config.flush_period);

										t.setEventTimeout();
									});
							},
						},
					]),
					t
				);
			})();

			(e.default = u), (t.exports = e.default);
		},
		function (t, e, r) {
			function n() {}

			function i(t) {
				var e = {}.toString.call(t);

				switch (e) {
					case "[object File]":
					case "[object Blob]":
					case "[object FormData]":
						return !0;

					default:
						return !1;
				}
			}

			function s(t) {
				if (!b(t)) return t;
				var e = [];

				for (var _r2 in t) {
					t[_r2] != null && o(e, _r2, t[_r2]);
				}

				return e.join("&");
			}

			function o(t, e, r) {
				return Array.isArray(r)
					? r.forEach(function (r) {
							o(t, e, r);
						})
					: void t.push(encodeURIComponent(e) + "=" + encodeURIComponent(r));
			}

			function a(t) {
				for (
					var e, r, n = {}, i = t.split("&"), s = 0, o = i.length;
					o > s;
					++s
				) {
					(r = i[s]),
						(e = r.split("=")),
						(n[decodeURIComponent(e[0])] = decodeURIComponent(e[1]));
				}

				return n;
			}

			function u(t) {
				var e;
				var r;
				var n;
				var i;
				var s = t.split(/\r?\n/);
				var o = {};
				s.pop();

				for (var _a = 0, _u = s.length; _u > _a; ++_a) {
					(r = s[_a]),
						(e = r.indexOf(":")),
						(n = r.slice(0, e).toLowerCase()),
						(i = g(r.slice(e + 1))),
						(o[n] = i);
				}

				return o;
			}

			function h(t) {
				return /[\/+]json\b/.test(t);
			}

			function c(t) {
				return t.split(/ *; */).shift();
			}

			function l(t) {
				return m(
					t.split(/ *; */),
					function (t, e) {
						var r = e.split(/ *= */);
						var n = r.shift();
						var i = r.shift();
						return n && i && (t[n] = i), t;
					},
					{}
				);
			}

			function p(t, e) {
				(e = e || {}),
					(this.req = t),
					(this.xhr = this.req.xhr),
					(this.text =
						(this.req.method != "HEAD" &&
							(this.xhr.responseType === "" ||
								this.xhr.responseType === "text")) ||
						typeof this.xhr.responseType === "undefined"
							? this.xhr.responseText
							: null),
					(this.statusText = this.req.xhr.statusText),
					this.setStatusProperties(this.xhr.status),
					(this.header = this.headers = u(this.xhr.getAllResponseHeaders())),
					(this.header["content-type"] = this.xhr.getResponseHeader(
						"content-type"
					)),
					this.setHeaderProperties(this.header),
					(this.body =
						this.req.method != "HEAD"
							? this.parseBody(this.text ? this.text : this.xhr.response)
							: null);
			}

			function f(t, e) {
				var r = this;
				(this._query = this._query || []),
					(this.method = t),
					(this.url = e),
					(this.header = {}),
					(this._header = {}),
					this.on("end", function () {
						var t = null;
						var e = null;

						try {
							e = new p(r);
						} catch (n) {
							return (
								(t = new Error("Parser is unable to parse the response")),
								(t.parse = !0),
								(t.original = n),
								(t.rawResponse =
									r.xhr && r.xhr.responseText ? r.xhr.responseText : null),
								(t.statusCode = r.xhr && r.xhr.status ? r.xhr.status : null),
								r.callback(t)
							);
						}

						if ((r.emit("response", e), t)) return r.callback(t, e);
						if (e.status >= 200 && e.status < 300) return r.callback(t, e);
						var i = new Error(e.statusText || "Unsuccessful HTTP response");
						(i.original = t),
							(i.response = e),
							(i.status = e.status),
							r.callback(i, e);
					});
			}

			function d(t, e) {
				var r = w("DELETE", t);
				return e && r.end(e), r;
			}

			var y;
			var v = r(2);
			var m = r(3);

			var _ = r(4);

			var b = r(5);
			y =
				typeof window !== "undefined"
					? window
					: typeof self !== "undefined"
					? self
					: this;
			var w = (t.exports = r(6).bind(null, f));

			w.getXHR = function () {
				if (
					!(
						!y.XMLHttpRequest ||
						(y.location && y.location.protocol == "file:" && y.ActiveXObject)
					)
				)
					return new XMLHttpRequest();

				try {
					return new ActiveXObject("Microsoft.XMLHTTP");
				} catch (t) {}

				try {
					return new ActiveXObject("Msxml2.XMLHTTP.6.0");
				} catch (t) {}

				try {
					return new ActiveXObject("Msxml2.XMLHTTP.3.0");
				} catch (t) {}

				try {
					return new ActiveXObject("Msxml2.XMLHTTP");
				} catch (t) {}

				return !1;
			};

			var g = "".trim
				? function (t) {
						return t.trim();
					}
				: function (t) {
						return t.replace(/(^\s*|\s*$)/g, "");
					};
			(w.serializeObject = s),
				(w.parseString = a),
				(w.types = {
					html: "text/html",
					json: "application/json",
					xml: "application/xml",
					urlencoded: "application/x-www-form-urlencoded",
					form: "application/x-www-form-urlencoded",
					"form-data": "application/x-www-form-urlencoded",
				}),
				(w.serialize = {
					"application/x-www-form-urlencoded": s,
					"application/json": JSON.stringify,
				}),
				(w.parse = {
					"application/x-www-form-urlencoded": a,
					"application/json": JSON.parse,
				}),
				(p.prototype.get = function (t) {
					return this.header[t.toLowerCase()];
				}),
				(p.prototype.setHeaderProperties = function (t) {
					var e = this.header["content-type"] || "";
					this.type = c(e);
					var r = l(e);

					for (var _n2 in r) {
						this[_n2] = r[_n2];
					}
				}),
				(p.prototype.parseBody = function (t) {
					var e = w.parse[this.type];
					return (
						!e && h(this.type) && (e = w.parse["application/json"]),
						e && t && (t.length || t instanceof Object) ? e(t) : null
					);
				}),
				(p.prototype.setStatusProperties = function (t) {
					t === 1223 && (t = 204);
					var e = (t / 100) | 0;
					(this.status = this.statusCode = t),
						(this.statusType = e),
						(this.info = e == 1),
						(this.ok = e == 2),
						(this.clientError = e == 4),
						(this.serverError = e == 5),
						(this.error = e == 4 || e == 5 ? this.toError() : !1),
						(this.accepted = t == 202),
						(this.noContent = t == 204),
						(this.badRequest = t == 400),
						(this.unauthorized = t == 401),
						(this.notAcceptable = t == 406),
						(this.notFound = t == 404),
						(this.forbidden = t == 403);
				}),
				(p.prototype.toError = function () {
					var t = this.req;
					var e = t.method;
					var r = t.url;
					var n = "cannot " + e + " " + r + " (" + this.status + ")";
					var i = new Error(n);
					return (i.status = this.status), (i.method = e), (i.url = r), i;
				}),
				(w.Response = p),
				v(f.prototype);

			for (var x in _) {
				f.prototype[x] = _[x];
			}

			(f.prototype.abort = function () {
				return this.aborted
					? void 0
					: ((this.aborted = !0),
						this.xhr && this.xhr.abort(),
						this.clearTimeout(),
						this.emit("abort"),
						this);
			}),
				(f.prototype.type = function (t) {
					return this.set("Content-Type", w.types[t] || t), this;
				}),
				(f.prototype.responseType = function (t) {
					return (this._responseType = t), this;
				}),
				(f.prototype.accept = function (t) {
					return this.set("Accept", w.types[t] || t), this;
				}),
				(f.prototype.auth = function (t, e, r) {
					switch (
						(r ||
							(r = {
								type: "basic",
							}),
						r.type)
					) {
						case "basic":
							var n = btoa(t + ":" + e);
							this.set("Authorization", "Basic " + n);
							break;

						case "auto":
							(this.username = t), (this.password = e);
					}

					return this;
				}),
				(f.prototype.query = function (t) {
					return (
						typeof t !== "string" && (t = s(t)), t && this._query.push(t), this
					);
				}),
				(f.prototype.attach = function (t, e, r) {
					return this._getFormData().append(t, e, r || e.name), this;
				}),
				(f.prototype._getFormData = function () {
					return (
						this._formData || (this._formData = new y.FormData()),
						this._formData
					);
				}),
				(f.prototype.send = function (t) {
					var e = b(t);
					var r = this._header["content-type"];
					if (e && b(this._data))
						for (var _n3 in t) {
							this._data[_n3] = t[_n3];
						}
					else
						typeof t === "string"
							? (r || this.type("form"),
								(r = this._header["content-type"]),
								r == "application/x-www-form-urlencoded"
									? (this._data = this._data ? this._data + "&" + t : t)
									: (this._data = (this._data || "") + t))
							: (this._data = t);
					return !e || i(t) ? this : (r || this.type("json"), this);
				}),
				(p.prototype.parse = function (t) {
					return y.console, this.serialize(t), this;
				}),
				(p.prototype.serialize = function (t) {
					return (this._parser = t), this;
				}),
				(f.prototype.callback = function (t, e) {
					var r = this._callback;
					this.clearTimeout(), r(t, e);
				}),
				(f.prototype.crossDomainError = function () {
					var t = new Error(
						"Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc."
					);
					(t.crossDomain = !0),
						(t.status = this.status),
						(t.method = this.method),
						(t.url = this.url),
						this.callback(t);
				}),
				(f.prototype.timeoutError = function () {
					var t = this._timeout;
					var e = new Error("timeout of " + t + "ms exceeded");
					(e.timeout = t), this.callback(e);
				}),
				(f.prototype.withCredentials = function () {
					return (this._withCredentials = !0), this;
				}),
				(f.prototype.end = function (t) {
					var e = this;
					var r = (this.xhr = w.getXHR());

					var s = this._query.join("&");

					var o = this._timeout;
					var a = this._formData || this._data;
					(this._callback = t || n),
						(r.onreadystatechange = function () {
							if (r.readyState == 4) {
								var _t;

								try {
									_t = r.status;
								} catch (n) {
									_t = 0;
								}

								if (_t == 0) {
									if (e.timedout) return e.timeoutError();
									if (e.aborted) return;
									return e.crossDomainError();
								}

								e.emit("end");
							}
						});

					var u = function u(t) {
						t.total > 0 && (t.percent = (t.loaded / t.total) * 100),
							(t.direction = "download"),
							e.emit("progress", t);
					};

					this.hasListeners("progress") && r.addEventListener("progress", u);

					try {
						r.upload &&
							this.hasListeners("progress") &&
							r.upload.addEventListener("progress", u);
					} catch (c) {}

					if (
						(o &&
							!this._timer &&
							(this._timer = setTimeout(function () {
								(e.timedout = !0), e.abort();
							}, o)),
						s &&
							((s = w.serializeObject(s)),
							(this.url += ~this.url.indexOf("?") ? "&" + s : "?" + s)),
						this.username && this.password
							? r.open(this.method, this.url, !0, this.username, this.password)
							: r.open(this.method, this.url, !0),
						this._withCredentials && (r.withCredentials = !0),
						this.method != "GET" &&
							this.method != "HEAD" &&
							typeof a !== "string" &&
							!i(a))
					) {
						var _l = this._header["content-type"];

						var _p = this._parser || w.serialize[_l ? _l.split(";")[0] : ""];

						!_p && h(_l) && (_p = w.serialize["application/json"]),
							_p && (a = _p(a));
					}

					for (var _f in this.header) {
						this.header[_f] != null && r.setRequestHeader(_f, this.header[_f]);
					}

					return (
						this._responseType && (r.responseType = this._responseType),
						this.emit("request", this),
						r.send(typeof a !== "undefined" ? a : null),
						this
					);
				}),
				(w.Request = f),
				(w.get = function (t, e, r) {
					var n = w("GET", t);
					return (
						typeof e === "function" && ((r = e), (e = null)),
						e && n.query(e),
						r && n.end(r),
						n
					);
				}),
				(w.head = function (t, e, r) {
					var n = w("HEAD", t);
					return (
						typeof e === "function" && ((r = e), (e = null)),
						e && n.send(e),
						r && n.end(r),
						n
					);
				}),
				(w.del = d),
				(w.delete = d),
				(w.patch = function (t, e, r) {
					var n = w("PATCH", t);
					return (
						typeof e === "function" && ((r = e), (e = null)),
						e && n.send(e),
						r && n.end(r),
						n
					);
				}),
				(w.post = function (t, e, r) {
					var n = w("POST", t);
					return (
						typeof e === "function" && ((r = e), (e = null)),
						e && n.send(e),
						r && n.end(r),
						n
					);
				}),
				(w.put = function (t, e, r) {
					var n = w("PUT", t);
					return (
						typeof e === "function" && ((r = e), (e = null)),
						e && n.send(e),
						r && n.end(r),
						n
					);
				});
		},
		function (t, e, r) {
			function n(t) {
				return t ? i(t) : void 0;
			}

			function i(t) {
				for (var _e2 in n.prototype) {
					t[_e2] = n.prototype[_e2];
				}

				return t;
			}

			(t.exports = n),
				(n.prototype.on = n.prototype.addEventListener = function (t, e) {
					return (
						(this._callbacks = this._callbacks || {}),
						(this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e),
						this
					);
				}),
				(n.prototype.once = function (t, e) {
					function r() {
						this.off(t, r), e.apply(this, arguments);
					}

					return (r.fn = e), this.on(t, r), this;
				}),
				(n.prototype.off = n.prototype.removeListener = n.prototype.removeAllListeners = n.prototype.removeEventListener = function (
					t,
					e
				) {
					if (
						((this._callbacks = this._callbacks || {}), arguments.length == 0)
					)
						return (this._callbacks = {}), this;
					var r = this._callbacks["$" + t];
					if (!r) return this;
					if (arguments.length == 1)
						return delete this._callbacks["$" + t], this;

					for (var n, i = 0; i < r.length; i++) {
						if (((n = r[i]), n === e || n.fn === e)) {
							r.splice(i, 1);
							break;
						}
					}

					return this;
				}),
				(n.prototype.emit = function (t) {
					this._callbacks = this._callbacks || {};
					var e = [].slice.call(arguments, 1);
					var r = this._callbacks["$" + t];

					if (r) {
						r = r.slice(0);

						for (var _n4 = 0, _i = r.length; _i > _n4; ++_n4) {
							r[_n4].apply(this, e);
						}
					}

					return this;
				}),
				(n.prototype.listeners = function (t) {
					return (
						(this._callbacks = this._callbacks || {}),
						this._callbacks["$" + t] || []
					);
				}),
				(n.prototype.hasListeners = function (t) {
					return Boolean(this.listeners(t).length);
				});
		},
		function (t, e) {
			t.exports = function (t, e, r) {
				for (
					var n = 0, i = t.length, s = arguments.length == 3 ? r : t[n++];
					i > n;

				) {
					s = e.call(null, s, t[n], ++n, t);
				}

				return s;
			};
		},
		function (t, e, r) {
			var n = r(5);
			(e.clearTimeout = function () {
				return (this._timeout = 0), clearTimeout(this._timer), this;
			}),
				(e.parse = function (t) {
					return (this._parser = t), this;
				}),
				(e.timeout = function (t) {
					return (this._timeout = t), this;
				}),
				(e.then = function (t, e) {
					return this.end(function (r, n) {
						r ? e(r) : t(n);
					});
				}),
				(e.use = function (t) {
					return t(this), this;
				}),
				(e.get = function (t) {
					return this._header[t.toLowerCase()];
				}),
				(e.getHeader = e.get),
				(e.set = function (t, e) {
					if (n(t)) {
						for (var _r3 in t) {
							this.set(_r3, t[_r3]);
						}

						return this;
					}

					return (
						(this._header[t.toLowerCase()] = e), (this.header[t] = e), this
					);
				}),
				(e.unset = function (t) {
					return (
						delete this._header[t.toLowerCase()], delete this.header[t], this
					);
				}),
				(e.field = function (t, e) {
					return this._getFormData().append(t, e), this;
				});
		},
		function (t, e) {
			function r(t) {
				return t != null && _typeof(t) === "object";
			}

			t.exports = r;
		},
		function (t, e) {
			function r(t, e, r) {
				return typeof r === "function"
					? new t("GET", e).end(r)
					: arguments.length == 2
					? new t("GET", e)
					: new t(e, r);
			}

			t.exports = r;
		},
	]);
});
!(function (e, t) {
	if (
		(typeof exports === "undefined" ? "undefined" : _typeof(exports)) ===
			"object" &&
		(typeof module === "undefined" ? "undefined" : _typeof(module)) === "object"
	)
		module.exports = t();
	else if (typeof define === "function" && define.amd) define([], t);
	else {
		var n = t();

		for (var r in n) {
			((typeof exports === "undefined" ? "undefined" : _typeof(exports)) ===
			"object"
				? exports
				: e)[r] = n[r];
		}
	}
})(this, function () {
	return (function (e) {
		function t(r) {
			if (n[r]) return n[r].exports;
			var o = (n[r] = {
				i: r,
				l: !1,
				exports: {},
			});
			return e[r].call(o.exports, o, o.exports, t), (o.l = !0), o.exports;
		}

		var n = {};
		return (
			(t.m = e),
			(t.c = n),
			(t.i = function (e) {
				return e;
			}),
			(t.d = function (e, n, r) {
				t.o(e, n) ||
					Object.defineProperty(e, n, {
						configurable: !1,
						enumerable: !0,
						get: r,
					});
			}),
			(t.n = function (e) {
				var n =
					e && e.__esModule
						? function () {
								return e.default;
							}
						: function () {
								return e;
							};
				return t.d(n, "a", n), n;
			}),
			(t.o = function (e, t) {
				return Object.prototype.hasOwnProperty.call(e, t);
			}),
			(t.p = ""),
			t((t.s = 42))
		);
	})([
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var s = (function () {
				function e(e, t) {
					for (var _n5 = 0; _n5 < t.length; _n5++) {
						var _r4 = t[_n5];
						(_r4.enumerable = _r4.enumerable || !1),
							(_r4.configurable = !0),
							"value" in _r4 && (_r4.writable = !0),
							Object.defineProperty(e, _r4.key, _r4);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var u = n(1);
			var c = (r(u), n(8));
			var l = r(c);
			var f = n(5);
			var d = r(f);
			var p = n(16);
			var b = r(p);

			var y = (function (e) {
				function t() {
					return (
						o(this, t),
						i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this))
					);
				}

				return (
					a(t, e),
					s(t, [
						{
							key: "setEventMetaAction",
							value: function value(e) {
								return (
									b.default.indexOf(e) > -1 &&
										((this.model["event-meta-action"] = e),
										this.revertFlatteningMethod()),
									this
								);
							},
						},
						{
							key: "setEventAction",
							value: function value(e) {
								return (
									typeof e === "string" &&
										((this.model["event-action"] = e),
										this.revertFlatteningMethod()),
									this
								);
							},
						},
						{
							key: "setUiLocation",
							value: function value(e) {
								return (
									e instanceof d.default &&
										((this.model["ui-location"] = e),
										this.revertFlatteningMethod()),
									this
								);
							},
						},
					]),
					t
				);
			})(l.default);

			t.default = y;
		},
		function (e, t, n) {
			"use strict";

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var r =
				typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol"
					? function (e) {
							return _typeof(e);
						}
					: function (e) {
							return e &&
								typeof Symbol === "function" &&
								e.constructor === Symbol &&
								e !== Symbol.prototype
								? "symbol"
								: _typeof(e);
						};

			t.default = function (e) {
				return (void 0 === e ? "undefined" : r(e)) === "object" &&
					e.constructor &&
					e.constructor.name
					? e.constructor.name
					: void 0 === e
					? "undefined"
					: r(e);
			};
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var i = (function () {
				function e(e, t) {
					for (var _n6 = 0; _n6 < t.length; _n6++) {
						var _r5 = t[_n6];
						(_r5.enumerable = _r5.enumerable || !1),
							(_r5.configurable = !0),
							"value" in _r5 && (_r5.writable = !0),
							Object.defineProperty(e, _r5.key, _r5);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var a = n(4);
			var s = r(a);
			var u = n(6);
			var c = r(u);
			var l = n(3);
			var f = r(l);
			var d = n(1);
			var p =
				(r(d),
				(function () {
					function e(t, n) {
						o(this, e),
							t && this.setBusinessDomainType(t),
							n && this.setObjectId(n);
					}

					return (
						i(e, [
							{
								key: "setBusinessDomainType",
								value: function value(e) {
									e instanceof s.default && (this["business-domain-type"] = e);
								},
							},
							{
								key: "setObjectId",
								value: function value(e) {
									e instanceof c.default && (this["object-id"] = e);
								},
							},
							{
								key: "setMetaData",
								value: function value(e) {
									e instanceof f.default &&
										((this.metadata = this.metadata || []),
										this.metadata.push(e));
								},
							},
						]),
						e
					);
				})());
			t.default = p;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var s = (function () {
				function e(e, t) {
					for (var _n7 = 0; _n7 < t.length; _n7++) {
						var _r6 = t[_n7];
						(_r6.enumerable = _r6.enumerable || !1),
							(_r6.configurable = !0),
							"value" in _r6 && (_r6.writable = !0),
							Object.defineProperty(e, _r6.key, _r6);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var u = n(6);
			var c = r(u);
			var l = n(1);
			var f =
				(r(l),
				(function (e) {
					function t(e, n, r, a) {
						o(this, t);
						var s = i(
							this,
							(t.__proto__ || Object.getPrototypeOf(t)).call(this, n, r, a)
						);
						return e && s.setKey(e), s;
					}

					return (
						a(t, e),
						s(t, [
							{
								key: "setKey",
								value: function value(e) {
									typeof e === "string" && (this.key = e);
								},
							},
						]),
						t
					);
				})(c.default));
			t.default = f;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var o = (function () {
				function e(e, t) {
					for (var _n8 = 0; _n8 < t.length; _n8++) {
						var _r7 = t[_n8];
						(_r7.enumerable = _r7.enumerable || !1),
							(_r7.configurable = !0),
							"value" in _r7 && (_r7.writable = !0),
							Object.defineProperty(e, _r7.key, _r7);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var i = n(1);
			var a =
				((function (e) {
					e && e.__esModule;
				})(i),
				(function () {
					function e(t, n) {
						r(this, e),
							t && this.setBusinessDomain(t),
							n && this.setBusinessObjectType(n);
					}

					return (
						o(e, [
							{
								key: "setBusinessDomain",
								value: function value(e) {
									typeof e === "string" && (this["business-domain"] = e);
								},
							},
							{
								key: "setBusinessObjectType",
								value: function value(e) {
									typeof e === "string" && (this["business-object-type"] = e);
								},
							},
						]),
						e
					);
				})());
			t.default = a;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var o = (function () {
				function e(e, t) {
					for (var _n9 = 0; _n9 < t.length; _n9++) {
						var _r8 = t[_n9];
						(_r8.enumerable = _r8.enumerable || !1),
							(_r8.configurable = !0),
							"value" in _r8 && (_r8.writable = !0),
							Object.defineProperty(e, _r8.key, _r8);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var i = n(1);
			var a =
				((function (e) {
					e && e.__esModule;
				})(i),
				(function () {
					function e(t) {
						r(this, e), t && this.setName(t);
					}

					return (
						o(e, [
							{
								key: "setName",
								value: function value(e) {
									typeof e === "string" && (this.name = e);
								},
							},
						]),
						e
					);
				})());
			t.default = a;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var s =
				typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol"
					? function (e) {
							return _typeof(e);
						}
					: function (e) {
							return e &&
								typeof Symbol === "function" &&
								e.constructor === Symbol &&
								e !== Symbol.prototype
								? "symbol"
								: _typeof(e);
						};

			var u = (function () {
				function e(e, t) {
					for (var _n10 = 0; _n10 < t.length; _n10++) {
						var _r9 = t[_n10];
						(_r9.enumerable = _r9.enumerable || !1),
							(_r9.configurable = !0),
							"value" in _r9 && (_r9.writable = !0),
							Object.defineProperty(e, _r9.key, _r9);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var c = n(38);
			var l = r(c);
			var f = n(1);
			var d =
				(r(f),
				(function (e) {
					function t(e, n, r) {
						o(this, t);
						var a = i(
							this,
							(t.__proto__ || Object.getPrototypeOf(t)).call(this, n, r)
						);
						return void 0 !== e && a.setValue(e), a;
					}

					return (
						a(t, e),
						u(t, [
							{
								key: "setValue",
								value: function value(e) {
									if (
										typeof e === "string" ||
										typeof e === "number" ||
										typeof e === "boolean" ||
										Array.isArray(e)
									) {
										if (Array.isArray(e))
											for (
												var _t2 = e.length,
													_n11 = void 0,
													_r10 = void 0,
													_o = 0;
												_o < _t2;
												_o++
											) {
												if (
													(_n11 = s(e[_o])) != "string" &&
													_n11 != "number" &&
													_n11 != "boolean"
												)
													return;
												if (_o === 0) _r10 = _n11;
												else if (_n11 != _r10) return;
											}
										this.value = e;
									}
								},
							},
						]),
						t
					);
				})(l.default));
			t.default = d;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var i = (function () {
				function e(e, t) {
					for (var _n12 = 0; _n12 < t.length; _n12++) {
						var _r11 = t[_n12];
						(_r11.enumerable = _r11.enumerable || !1),
							(_r11.configurable = !0),
							"value" in _r11 && (_r11.writable = !0),
							Object.defineProperty(e, _r11.key, _r11);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var a = n(1);
			var s = (r(a), n(5));
			var u = r(s);

			var c = (function () {
				function e(t, n) {
					o(this, e),
						t && (this.setName(t), n && this.setEnclosingUiLocation(n));
				}

				return (
					i(e, [
						{
							key: "setName",
							value: function value(e) {
								typeof e === "string" && (this.name = e);
							},
						},
						{
							key: "setEnclosingUiLocation",
							value: function value(e) {
								this.enclosingUILocation = new u.default(e);
							},
						},
					]),
					e
				);
			})();

			t.default = c;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var i = (function () {
				function e(e, t) {
					for (var _n13 = 0; _n13 < t.length; _n13++) {
						var _r12 = t[_n13];
						(_r12.enumerable = _r12.enumerable || !1),
							(_r12.configurable = !0),
							"value" in _r12 && (_r12.writable = !0),
							Object.defineProperty(e, _r12.key, _r12);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var a = n(39);
			var s = r(a);
			var u = n(1);
			var c = (r(u), n(12));
			var l = r(c);
			var f = n(19);
			var d = r(f);
			var p = n(4);
			var b = r(p);
			var y = n(2);
			var h = r(y);
			var w = n(11);
			var v = r(w);
			var m = n(17);

			var _ = r(m);

			var g = n(40);
			var O = r(g);
			var j = n(6);
			var k = r(j);
			var E = n(3);
			var x = r(E);
			var P = n(20);
			var M = r(P);
			var T = n(10);
			var C = r(T);
			var S = n(9);
			var A = r(S);

			var N = (function () {
				function e() {
					o(this, e),
						(this.model = {}),
						(this.model["event-id"] = (0, d.default)()),
						(this.model.tmpMetaData = {
							flatteningMethod: "concise",
						}),
						this.setTimestamp(new Date()),
						this.setSuperProperties(),
						this.setUser();
				}

				return (
					i(e, [
						{
							key: "revertFlatteningMethod",
							value: function value() {
								this.model.tmpMetaData.flatteningMethod = "legacy";
							},
						},
						{
							key: "setPrimaryBusinessDomainObjectType",
							value: function value(e) {
								return (
									e instanceof b.default &&
										((this.model["primary-business-domain-object-type"] = e),
										this.revertFlatteningMethod()),
									this
								);
							},
						},
						{
							key: "setTimestamp",
							value: function value(e) {
								return (
									e
										? typeof e === "number"
											? (this.model["event-timestamp"] = e)
											: e instanceof Date &&
												(this.model["event-timestamp"] = e.getTime() / 1e3)
										: (this.model["event-timestamp"] =
												new Date().getTime() / 1e3),
									this
								);
							},
						},
						{
							key: "setEventExternalName",
							value: function value(e) {
								return (this.model["event-external-name"] = e), this;
							},
						},
						{
							key: "setUser",
							value: function value(e) {
								var t = l.default.get("traacUserId");

								if (t) {
									var _n14 = new v.default("product");

									(e = e || "default"),
										_n14.setUser(
											new h.default(new b.default(e, "user"), new k.default(t))
										),
										this.setContext(_n14);
								}
							},
						},
						{
							key: "setEventOriginator",
							value: function value(e) {
								return (
									_.default.indexOf(e) > -1 &&
										((this.model["event-originiator"] = e),
										this.revertFlatteningMethod()),
									this
								);
							},
						},
						{
							key: "setRelatedEvents",
							value: function value(e) {
								return (
									e instanceof C.default &&
										((this.model["related-events"] =
											this.model["related-events"] || []),
										this.model["related-events"].push(e),
										this.revertFlatteningMethod()),
									this
								);
							},
						},
						{
							key: "setContext",
							value: function value(e) {
								return (
									e instanceof v.default &&
										((this.model.contexts = this.model.contexts || []),
										this.model.contexts.push(e)),
									this
								);
							},
						},
						{
							key: "setRelatedBusinessDomainObject",
							value: function value(e) {
								return (
									e instanceof A.default &&
										((this.model["related-domain-objects"] =
											this.model["related-domain-objects"] || []),
										this.model["related-domain-objects"].push(e),
										this.revertFlatteningMethod()),
									this
								);
							},
						},
						{
							key: "setMetaData",
							value: function value(e) {
								return (
									e instanceof x.default &&
										((this.model.metadata = this.model.metadata || []),
										this.model.metadata.push(e)),
									this
								);
							},
						},
						{
							key: "setPlatformContext",
							value: function value() {
								var e = new O.default();
								var t = new v.default("platform");
								t.setMetaData(new x.default("browser", e.getBrowser().name)),
									t.setMetaData(
										new x.default("browser-version", e.getBrowser().version)
									),
									t.setMetaData(new x.default("os", e.getOS().name)),
									t.setMetaData(new x.default("os-version", e.getOS().version)),
									t.setMetaData(new x.default("user-agent", e.getUA())),
									t.setMetaData(
										new x.default("current-url", window.location.href)
									),
									t.setMetaData(
										new x.default("viewport-height", M.default.height)
									),
									t.setMetaData(
										new x.default("viewport-width", M.default.width)
									),
									t.setMetaData(new x.default("screen-height", screen.height)),
									t.setMetaData(new x.default("screen-width", screen.width)),
									t.setMetaData(new x.default("traac-sdk", "javascript")),
									t.setMetaData(
										new x.default("traac-sdk-version", s.default.version)
									),
									t.setMetaData(new x.default("traac-model-version", "2.2.6")),
									t.setMetaData(
										new x.default(
											"traac-flattening-method",
											this.model.tmpMetaData.flatteningMethod
										)
									);
								var n = l.default.getJSON("traacRef");
								if (n)
									for (var _r13 in n) {
										t.setMetaData(new x.default(_r13, n[_r13]));
									}
								this.setContext(t);
							},
						},
						{
							key: "setSuperProperties",
							value: function value() {
								var e = l.default.getJSON("traac");
								var t = new v.default("product");

								if (e) {
									for (var _n15 in e) {
										t.setMetaData(new x.default(_n15, e[_n15]));
									}

									this.setContext(t);
								}
							},
						},
						{
							key: "build",
							value: function value() {
								return this.setPlatformContext(), this.model;
							},
						},
					]),
					e
				);
			})();

			t.default = N;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var s = (function () {
				function e(e, t) {
					for (var _n16 = 0; _n16 < t.length; _n16++) {
						var _r14 = t[_n16];
						(_r14.enumerable = _r14.enumerable || !1),
							(_r14.configurable = !0),
							"value" in _r14 && (_r14.writable = !0),
							Object.defineProperty(e, _r14.key, _r14);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var u = n(2);
			var c = r(u);
			var l = n(1);
			var f =
				(r(l),
				(function (e) {
					function t(e) {
						o(this, t);
						var n = i(
							this,
							(t.__proto__ || Object.getPrototypeOf(t)).call(this)
						);
						return e && n.setRelationshipType(e), n;
					}

					return (
						a(t, e),
						s(t, [
							{
								key: "setRelationshipType",
								value: function value(e) {
									typeof e === "string" && (this["relationship-type"] = e);
								},
							},
						]),
						t
					);
				})(c.default));
			t.default = f;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var o = (function () {
				function e(e, t) {
					for (var _n17 = 0; _n17 < t.length; _n17++) {
						var _r15 = t[_n17];
						(_r15.enumerable = _r15.enumerable || !1),
							(_r15.configurable = !0),
							"value" in _r15 && (_r15.writable = !0),
							Object.defineProperty(e, _r15.key, _r15);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var i = n(1);
			var a =
				((function (e) {
					e && e.__esModule;
				})(i),
				(function () {
					function e(t, n) {
						r(this, e),
							t && this.setRelationshipType(t),
							n && this.setRelatedEventId(n);
					}

					return (
						o(e, [
							{
								key: "setRelationshipType",
								value: function value(e) {
									typeof e === "string" && (this["relationship-type"] = e);
								},
							},
							{
								key: "setRelatedEventId",
								value: function value(e) {
									typeof e === "string" && (this["relationship-event-id"] = e);
								},
							},
						]),
						e
					);
				})());
			t.default = a;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var i = (function () {
				function e(e, t) {
					for (var _n18 = 0; _n18 < t.length; _n18++) {
						var _r16 = t[_n18];
						(_r16.enumerable = _r16.enumerable || !1),
							(_r16.configurable = !0),
							"value" in _r16 && (_r16.writable = !0),
							Object.defineProperty(e, _r16.key, _r16);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var a = n(15);
			var s = r(a);
			var u = n(3);
			var c = r(u);
			var l = n(2);
			var f = r(l);
			var d = n(1);
			var p =
				(r(d),
				(function () {
					function e(t) {
						o(this, e), t && this.setContextType(t);
					}

					return (
						i(e, [
							{
								key: "setContextType",
								value: function value(e) {
									s.default.indexOf(e) > -1 && (this["context-type"] = e);
								},
							},
							{
								key: "setMetaData",
								value: function value(e) {
									e instanceof c.default &&
										((this.metadata = this.metadata || []),
										this.metadata.push(e));
								},
							},
							{
								key: "setUser",
								value: function value(e) {
									e instanceof f.default && (this.user = e);
								},
							},
						]),
						e
					);
				})());
			t.default = p;
		},
		function (e, t, n) {
			var r;
			var o;
			!(function (i) {
				var a = !1;

				if (
					((r = i),
					void 0 !== (o = typeof r === "function" ? r.call(t, n, t, e) : r) &&
						(e.exports = o),
					(a = !0),
					(e.exports = i()),
					(a = !0),
					!a)
				) {
					var s = window.Cookies;
					var u = (window.Cookies = i());

					u.noConflict = function () {
						return (window.Cookies = s), u;
					};
				}
			})(function () {
				function e() {
					for (var e = 0, t = {}; e < arguments.length; e++) {
						var _n19 = arguments[e];

						for (var _r17 in _n19) {
							t[_r17] = _n19[_r17];
						}
					}

					return t;
				}

				function t(n) {
					function r(t, o, i) {
						var a;

						if (typeof document !== "undefined") {
							if (arguments.length > 1) {
								if (
									((i = e(
										{
											path: "/",
										},
										r.defaults,
										i
									)),
									typeof i.expires === "number")
								) {
									var s = new Date();
									s.setMilliseconds(s.getMilliseconds() + 864e5 * i.expires),
										(i.expires = s);
								}

								i.expires = i.expires ? i.expires.toUTCString() : "";

								try {
									(a = JSON.stringify(o)), /^[\{\[]/.test(a) && (o = a);
								} catch (e) {}

								(o = n.write
									? n.write(o, t)
									: encodeURIComponent(String(o)).replace(
											/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
											decodeURIComponent
										)),
									(t = encodeURIComponent(String(t))),
									(t = t.replace(
										/%(23|24|26|2B|5E|60|7C)/g,
										decodeURIComponent
									)),
									(t = t.replace(/[\(\)]/g, escape));
								var u = "";

								for (var c in i) {
									i[c] && ((u += "; " + c), !0 !== i[c] && (u += "=" + i[c]));
								}

								return (document.cookie = t + "=" + o + u);
							}

							t || (a = {});

							for (
								var l = document.cookie ? document.cookie.split("; ") : [],
									f = /(%[0-9A-Z]{2})+/g,
									d = 0;
								d < l.length;
								d++
							) {
								var p = l[d].split("=");
								var b = p.slice(1).join("=");
								this.json || b.charAt(0) !== '"' || (b = b.slice(1, -1));

								try {
									var y = p[0].replace(f, decodeURIComponent);
									if (
										((b = n.read
											? n.read(b, y)
											: n(b, y) || b.replace(f, decodeURIComponent)),
										this.json)
									)
										try {
											b = JSON.parse(b);
										} catch (e) {}

									if (t === y) {
										a = b;
										break;
									}

									t || (a[y] = b);
								} catch (e) {}
							}

							return a;
						}
					}

					return (
						(r.set = r),
						(r.get = function (e) {
							return r.call(r, e);
						}),
						(r.getJSON = function () {
							return r.apply(
								{
									json: !0,
								},
								[].slice.call(arguments)
							);
						}),
						(r.defaults = {}),
						(r.remove = function (t, n) {
							r(
								t,
								"",
								e(n, {
									expires: -1,
								})
							);
						}),
						(r.withConverter = t),
						r
					);
				}

				return t(function () {});
			});
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			var i =
				typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol"
					? function (e) {
							return _typeof(e);
						}
					: function (e) {
							return e &&
								typeof Symbol === "function" &&
								e.constructor === Symbol &&
								e !== Symbol.prototype
								? "symbol"
								: _typeof(e);
						};

			var a = (function () {
				function e(e, t) {
					for (var _n20 = 0; _n20 < t.length; _n20++) {
						var _r18 = t[_n20];
						(_r18.enumerable = _r18.enumerable || !1),
							(_r18.configurable = !0),
							"value" in _r18 && (_r18.writable = !0),
							Object.defineProperty(e, _r18.key, _r18);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var s = n(12);
			var u = r(s);
			var c = n(8);
			var l = r(c);
			var f = n(31);
			var d = r(f);
			var p = n(32);
			var b = r(p);
			var y = n(25);
			var h = r(y);
			var w = n(21);
			var v = r(w);
			var m = n(29);

			var _ = r(m);

			var g = n(27);
			var O = r(g);
			var j = n(30);
			var k = r(j);
			var E = n(37);
			var x = r(E);
			var P = n(23);
			var M = r(P);
			var T = n(22);
			var C = r(T);
			var S = n(28);
			var A = r(S);
			var N = n(24);
			var R = r(N);
			var D = n(36);
			var I = r(D);
			var U = n(33);
			var B = r(U);
			var F = n(34);
			var V = r(F);
			var z = n(35);
			var L = r(z);
			var G = n(26);
			var q = r(G);
			var H = n(5);
			var Q = r(H);
			var J = n(4);
			var W = r(J);
			var X = n(11);
			var K = r(X);
			var $ = n(3);
			var Z = r($);
			var Y = n(2);
			var ee = r(Y);
			var te = n(10);
			var ne = r(te);
			var re = n(9);
			var oe = r(re);
			var ie = n(14);
			var ae = r(ie);
			var se = n(1);
			var ue =
				(r(se),
				(function () {
					function e() {
						o(this, e),
							this.setInitialReferrer(),
							this.runAsyncEvents(),
							(window.traacProviderManager = new ae.default()),
							this.attachUnloadEvent();
					}

					return (
						a(e, [
							{
								key: "registerProvider",
								value: function value(e, t) {
									window.traacProviderManager.addProvider(e, t);
								},
							},
							{
								key: "attachUnloadEvent",
								value: function value() {
									var e = this;
									window.addEventListener("unload", function () {
										e.flush();
									});
								},
							},
							{
								key: "track",
								value: function value(e) {
									if (typeof e === "function")
										window.traacProviderManager.run("track", e.call(window));
									else if (
										(void 0 === e ? "undefined" : i(e)) === "object" &&
										e.eventType
									) {
										var _t3 = this[e.eventType](e.eventName, e.kvp).build();

										window.traacProviderManager.run("track", _t3);
									} else
										(void 0 === e ? "undefined" : i(e)) === "object" &&
											e["event-id"] &&
											window.traacProviderManager.run("track", e);
								},
							},
							{
								key: "flush",
								value: function value(e, t) {
									window.traacProviderManager.run("flush", {
										callback: e || function () {},
										timeout: t || 700,
									});
								},
							},
							{
								key: "register",
								value: function value(e, t) {
									if (e && (void 0 === e ? "undefined" : i(e)) == "object") {
										var _n21 = u.default.getJSON("traac");

										var _r19 = {};
										if (_n21)
											for (var _o2 in _n21) {
												_r19[_o2] = _n21[_o2];
											}

										for (var _a2 in e) {
											if (_r19[_a2] && t) break;
											_r19[_a2] = e[_a2];
										}

										u.default.set("traac", _r19, {
											expires: 365,
										});
									}
								},
							},
							{
								key: "registerOnce",
								value: function value(e) {
									this.register(e, !0);
								},
							},
							{
								key: "deRegister",
								value: function value(e) {
									var t = u.default.getJSON("traac");
									t &&
										t[e] &&
										(delete t[e],
										u.default.set("traac", t, {
											expires: 365,
										}));
								},
							},
							{
								key: "setUser",
								value: function value(e) {
									u.default.set("traacUserId", e, {
										expires: 365,
									});
								},
							},
							{
								key: "clearUser",
								value: function value() {
									u.default.remove("traacUserId");
								},
							},
							{
								key: "setInitialReferrer",
								value: function value() {
									var e = u.default.getJSON("traacRef") || {};

									var t = function t(e) {
										var t = e.split("/");
										if (t.length >= 3) return t[2];
									};

									document.referrer
										? e["initial-referring-domain"]
											? e["initial-referring-domain"] !==
													t(document.referrer) &&
												((e["initial-referring-domain"] = t(document.referrer)),
												(e["initial-referrer"] = document.referrer))
											: ((e["initial-referring-domain"] = t(document.referrer)),
												(e["initial-referrer"] = document.referrer))
										: e["initial-referring-domain"] ||
											((e["initial-referring-domain"] = "$direct"),
											(e["initial-referrer"] = "$direct")),
										u.default.set("traacRef", e, {
											expires: 365,
										});
								},
							},
							{
								key: "runAsyncEvents",
								value: function value() {
									var _this = this;

									setTimeout(function () {
										for (
											var _e3 = 0, _t4 = TRAAC_CONFIG.teq.length;
											_e3 < _t4;
											_e3++
										) {
											i(TRAAC_CONFIG.teq[_e3]) === "object" &&
											TRAAC_CONFIG.teq[_e3].method
												? _this[TRAAC_CONFIG.teq[_e3].method](
														TRAAC_CONFIG.teq[_e3].p1,
														TRAAC_CONFIG.teq[_e3].p2
													)
												: _this.track(TRAAC_CONFIG.teq[_e3]);
										}
									}, 0);
								},
							},
							{
								key: "set",
								value: function value(e) {
									return new d.default(e);
								},
							},
							{
								key: "transact",
								value: function value(e, t) {
									return new b.default(e, t);
								},
							},
							{
								key: "expressInterestOn",
								value: function value(e) {
									return new h.default(e);
								},
							},
							{
								key: "authenticate",
								value: function value(e, t, n) {
									return new v.default(e, t, n);
								},
							},
							{
								key: "refresh",
								value: function value(e) {
									return new _.default(e);
								},
							},
							{
								key: "print",
								value: function value(e) {
									return new O.default(e);
								},
							},
							{
								key: "search",
								value: function value(e) {
									return new k.default(e);
								},
							},
							{
								key: "update",
								value: function value(e) {
									return new x.default(e);
								},
							},
							{
								key: "delete",
								value: function value(e) {
									return new M.default(e);
								},
							},
							{
								key: "consume",
								value: function value(e) {
									return new C.default(e);
								},
							},
							{
								key: "produce",
								value: function value(e) {
									return new A.default(e);
								},
							},
							{
								key: "download",
								value: function value(e) {
									return new R.default(e);
								},
							},
							{
								key: "uiShow",
								value: function value(e, t, n) {
									return new I.default(e, t, n);
								},
							},
							{
								key: "uiHide",
								value: function value(e, t, n) {
									return new B.default(e, t, n);
								},
							},
							{
								key: "uiInteraction",
								value: function value(e, t, n) {
									return new V.default(e, t, n);
								},
							},
							{
								key: "uiNavigation",
								value: function value(e, t, n) {
									return new L.default(e, t, n);
								},
							},
							{
								key: "keyValue",
								value: function value(e, t) {
									return new q.default(e, t);
								},
							},
							{
								key: "getEventCoreObject",
								value: function value() {
									return new l.default();
								},
							},
							{
								key: "getUiLocationObject",
								value: function value(e) {
									return new Q.default(e);
								},
							},
							{
								key: "getBusinessDomainDefinitionObject",
								value: function value(e, t) {
									return new W.default(e, t);
								},
							},
							{
								key: "getSingleContextObject",
								value: function value(e) {
									return new K.default(e);
								},
							},
							{
								key: "getPiiKeyValueObject",
								value: function value(e, t) {
									return new Z.default(e, t);
								},
							},
							{
								key: "getBusinessDomainObject",
								value: function value(e, t) {
									return new ee.default(e, t);
								},
							},
							{
								key: "getRelatedEventObject",
								value: function value(e, t) {
									return new ne.default(e, t);
								},
							},
							{
								key: "getRelatedBusinessDomainObject",
								value: function value(e) {
									return new oe.default(e);
								},
							},
						]),
						e
					);
				})());
			window.TRAAC = new ue();
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var o = (function () {
				function e(e, t) {
					for (var _n22 = 0; _n22 < t.length; _n22++) {
						var _r20 = t[_n22];
						(_r20.enumerable = _r20.enumerable || !1),
							(_r20.configurable = !0),
							"value" in _r20 && (_r20.writable = !0),
							Object.defineProperty(e, _r20.key, _r20);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var i = (function () {
				function e() {
					r(this, e),
						(this.registeredProviders = []),
						this.registerConfiguredAdapters(),
						(this.eventCBQueue = []);
				}

				return (
					o(e, [
						{
							key: "registerConfiguredAdapters",
							value: function value() {
								for (
									var _e4 = 0, _t5 = TRAAC_CONFIG.adapters.length;
									_e4 < _t5;
									_e4++
								) {
									this.addProvider(
										TRAAC_CONFIG.adapters[_e4].type,
										TRAAC_CONFIG.adapters[_e4].config
									);
								}
							},
						},
						{
							key: "addProvider",
							value: function value(e, t) {
								var n = void 0;

								try {
									(e += "Adapter"), (n = new window[e](t));
								} catch (e) {
									return;
								}

								this.registeredProviders.push(n);
							},
						},
						{
							key: "run",
							value: function value(e, t) {
								for (var _n23 in this.registeredProviders) {
									this.registeredProviders.hasOwnProperty(_n23) &&
										this.registeredProviders[_n23][e](t, this.eventCBQueue);
								}

								if (e === "flush") {
									var _r21 = !1;

									setTimeout(function () {
										_r21 || ((_r21 = !0), t.callback());
									}, t.timeout);
									var _o3 = [];

									for (var _i2 in this.eventCBQueue) {
										this.eventCBQueue.hasOwnProperty(_i2) &&
											_o3.push(this.eventCBQueue[_i2]);
									}

									_o3.length > 0 &&
										Promise.all(_o3).then(function () {
											_r21 || ((_r21 = !0), t.callback());
										});
								}
							},
						},
					]),
					e
				);
			})();

			t.default = i;
		},
		function (e, t, n) {
			"use strict";

			Object.defineProperty(t, "__esModule", {
				value: !0,
			}),
				(t.default = ["temporal", "product", "geospatial", "platform"]);
		},
		function (e, t, n) {
			"use strict";

			Object.defineProperty(t, "__esModule", {
				value: !0,
			}),
				(t.default = [
					"ui-navigation",
					"ui-interaction",
					"ui-show",
					"ui-hide",
					"produce",
					"download",
					"consume",
					"delete",
					"update",
					"search",
					"print",
					"refresh",
					"authenticate",
					"express-interest-on",
					"set",
					"transact",
					"undefined",
				]);
		},
		function (e, t, n) {
			"use strict";

			Object.defineProperty(t, "__esModule", {
				value: !0,
			}),
				(t.default = ["user", "business-process", "system"]);
		},
		function (e, t, n) {
			"use strict";

			Object.defineProperty(t, "__esModule", {
				value: !0,
			}),
				(t.default = ["public", "private", "masked"]);
		},
		function (e, t, n) {
			"use strict";

			function r() {
				return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
					/[xy]/g,
					function (e) {
						var t = (16 * Math.random()) | 0;
						return (e == "x" ? t : (3 & t) | 8).toString(16);
					}
				);
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			}),
				(t.default = r);
		},
		function (e, t, n) {
			"use strict";

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var r = window;
			var o = document;
			var i = o.documentElement;
			var a = o.getElementsByTagName("body")[0];
			var s = r.innerWidth || i.clientWidth || a.clientWidth;
			var u = r.innerHeight || i.clientHeight || a.clientHeight;
			t.default = {
				width: s,
				height: u,
			};
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var s = n(0);
			var u = r(s);
			var c = n(2);
			var l = r(c);
			var f = n(4);
			var d = r(f);
			var p = n(6);
			var b = r(p);

			var y = (function (e) {
				function t(e, n, r) {
					o(this, t);
					var a = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return (
						a.setEventExternalName(e),
						a.setEventMetaAction("authenticate"),
						typeof n === "boolean" && (a.model.success = n),
						r &&
							typeof r === "number" &&
							(a.model.user = new l.default(
								new d.default("", "user"),
								new b.default(r)
							)),
						a
					);
				}

				return a(t, e), t;
			})(u.default);

			t.default = y;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return n.setEventExternalName(e), n.setEventMetaAction("consume"), n;
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return n.setEventExternalName(e), n.setEventMetaAction("delete"), n;
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return n.setEventExternalName(e), n.setEventMetaAction("download"), n;
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return (
						n.setEventExternalName(e),
						n.setEventMetaAction("express-interest-on"),
						n
					);
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var s = n(0);
			var u = r(s);
			var c = n(3);
			var l = r(c);

			var f = (function (e) {
				function t(e, n) {
					o(this, t);
					var r = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					r.setEventExternalName(e);

					for (var _a3 in n) {
						if (n.hasOwnProperty(_a3)) {
							var _s2 = n[_a3];
							r.setMetaData(new l.default(_a3, _s2));
						}
					}

					return r;
				}

				return a(t, e), t;
			})(u.default);

			t.default = f;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return n.setEventExternalName(e), n.setEventMetaAction("print"), n;
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return n.setEventExternalName(e), n.setEventMetaAction("produce"), n;
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return n.setEventExternalName(e), n.setEventMetaAction("refresh"), n;
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return n.setEventExternalName(e), n.setEventMetaAction("search"), n;
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return n.setEventExternalName(e), n.setEventMetaAction("set"), n;
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e, n) {
					r(this, t);
					var i = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return (
						i.setEventExternalName(e),
						(i.model.success = n),
						i.setEventMetaAction("transact"),
						i
					);
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var s = (function () {
				function e(e, t) {
					for (var _n24 = 0; _n24 < t.length; _n24++) {
						var _r22 = t[_n24];
						(_r22.enumerable = _r22.enumerable || !1),
							(_r22.configurable = !0),
							"value" in _r22 && (_r22.writable = !0),
							Object.defineProperty(e, _r22.key, _r22);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var u = n(0);
			var c = r(u);
			var l = n(7);
			var f = r(l);

			var d = (function (e) {
				function t(e, n, r) {
					o(this, t);
					var a = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return (
						a.setEventExternalName(e),
						a.setEventMetaAction("ui-hide"),
						n && a.setUIElement(n, r),
						a
					);
				}

				return (
					a(t, e),
					s(t, [
						{
							key: "setUIElement",
							value: function value(e, t) {
								this.model["ui-element"] = new f.default(e, t);
							},
						},
					]),
					t
				);
			})(c.default);

			t.default = d;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var s = (function () {
				function e(e, t) {
					for (var _n25 = 0; _n25 < t.length; _n25++) {
						var _r23 = t[_n25];
						(_r23.enumerable = _r23.enumerable || !1),
							(_r23.configurable = !0),
							"value" in _r23 && (_r23.writable = !0),
							Object.defineProperty(e, _r23.key, _r23);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var u = n(0);
			var c = r(u);
			var l = n(7);
			var f = r(l);

			var d = (function (e) {
				function t(e, n, r) {
					o(this, t);
					var a = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return (
						a.setEventExternalName(e),
						a.setEventMetaAction("ui-interaction"),
						n && a.setUIElement(n, r),
						a
					);
				}

				return (
					a(t, e),
					s(t, [
						{
							key: "setUIElement",
							value: function value(e, t) {
								this.model["ui-element"] = new f.default(e, t);
							},
						},
					]),
					t
				);
			})(c.default);

			t.default = d;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var s = (function () {
				function e(e, t) {
					for (var _n26 = 0; _n26 < t.length; _n26++) {
						var _r24 = t[_n26];
						(_r24.enumerable = _r24.enumerable || !1),
							(_r24.configurable = !0),
							"value" in _r24 && (_r24.writable = !0),
							Object.defineProperty(e, _r24.key, _r24);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var u = n(0);
			var c = r(u);
			var l = n(5);
			var f = r(l);

			var d = (function (e) {
				function t(e, n, r) {
					o(this, t);
					var a = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return (
						a.setEventExternalName(e),
						a.setEventMetaAction("ui-navigation"),
						n && a.setUILocationFrom(n),
						r && a.setUILocationTo(r),
						a
					);
				}

				return (
					a(t, e),
					s(t, [
						{
							key: "setUILocationFrom",
							value: function value(e) {
								this.model["ui-location-from"] = new f.default(e);
							},
						},
						{
							key: "setUILocationTo",
							value: function value(e) {
								this.model["ui-location-to"] = new f.default(e);
							},
						},
					]),
					t
				);
			})(c.default);

			t.default = d;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function i(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function a(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var s = (function () {
				function e(e, t) {
					for (var _n27 = 0; _n27 < t.length; _n27++) {
						var _r25 = t[_n27];
						(_r25.enumerable = _r25.enumerable || !1),
							(_r25.configurable = !0),
							"value" in _r25 && (_r25.writable = !0),
							Object.defineProperty(e, _r25.key, _r25);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var u = n(0);
			var c = r(u);
			var l = n(7);
			var f = r(l);

			var d = (function (e) {
				function t(e, n, r) {
					o(this, t);
					var a = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return (
						a.setEventExternalName(e),
						a.setEventMetaAction("ui-show"),
						n && a.setUIElement(n, r),
						a
					);
				}

				return (
					a(t, e),
					s(t, [
						{
							key: "setUIElement",
							value: function value(e, t) {
								this.model["ui-element"] = new f.default(e, t);
							},
						},
					]),
					t
				);
			})(c.default);

			t.default = d;
		},
		function (e, t, n) {
			"use strict";

			function r(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			function o(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || (_typeof(t) !== "object" && typeof t !== "function")
					? e
					: t;
			}

			function i(e, t) {
				if (typeof t !== "function" && t !== null)
					throw new TypeError(
						"Super expression must either be null or a function, not " +
							_typeof(t)
					);
				(e.prototype = Object.create(t && t.prototype, {
					constructor: {
						value: e,
						enumerable: !1,
						writable: !0,
						configurable: !0,
					},
				})),
					t &&
						(Object.setPrototypeOf
							? Object.setPrototypeOf(e, t)
							: (e.__proto__ = t));
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});
			var a = n(0);

			var s = (function (e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			})(a);

			var u = (function (e) {
				function t(e) {
					r(this, t);
					var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
					return n.setEventExternalName(e), n.setEventMetaAction("update"), n;
				}

				return i(t, e), t;
			})(s.default);

			t.default = u;
		},
		function (e, t, n) {
			"use strict";

			function r(e) {
				return e && e.__esModule
					? e
					: {
							default: e,
						};
			}

			function o(e, t) {
				if (!(e instanceof t))
					throw new TypeError("Cannot call a class as a function");
			}

			Object.defineProperty(t, "__esModule", {
				value: !0,
			});

			var i = (function () {
				function e(e, t) {
					for (var _n28 = 0; _n28 < t.length; _n28++) {
						var _r26 = t[_n28];
						(_r26.enumerable = _r26.enumerable || !1),
							(_r26.configurable = !0),
							"value" in _r26 && (_r26.writable = !0),
							Object.defineProperty(e, _r26.key, _r26);
					}
				}

				return function (t, n, r) {
					return n && e(t.prototype, n), r && e(t, r), t;
				};
			})();

			var a = n(18);
			var s = r(a);
			var u = n(1);
			var c =
				(r(u),
				(function () {
					function e(t, n) {
						o(this, e), this.setVisibility(t || "public"), n && this.setMask(n);
					}

					return (
						i(e, [
							{
								key: "setVisibility",
								value: function value(e) {
									s.default.indexOf(e) > -1 && (this.visibility = e);
								},
							},
							{
								key: "setMask",
								value: function value(e) {
									typeof e === "string" && (this.mask = e);
								},
							},
						]),
						e
					);
				})());
			t.default = c;
		},
		function (e, t) {
			e.exports = {
				name: "traac-web-core",
				version: "0.8.8",
				description: "Core library for web client traac integration.",
				scripts: {
					build: "webpack",
					"build-es-2015": "webpack --config ./webpack.es2015.config.js",
					"build-prod": "webpack && PROD_ENV=1 webpack",
					"build-es2015-prod":
						"webpack --config ./webpack.es2015.config.js && PROD_ENV=1 webpack --config ./webpack.es2015.config.js",
					test: "karma start --single-run",
					watch: "webpack --watch",
				},
				devDependencies: {
					"babel-core": "^6.26.3",
					"babel-loader": "^7.1.4",
					"babel-preset-env": "^1.7.0",
					"babel-preset-es2015": "latest",
					"babel-preset-stage-0": "latest",
					"css-loader": "^0.23.1",
					"jasmine-core": "^2.6.3",
					"json-loader": "^0.5.4",
					karma: "^1.7.0",
					"karma-chrome-launcher": "^2.1.1",
					"karma-jasmine": "^1.1.0",
					"karma-webpack": "^2.0.3",
					"style-loader": "^0.13.0",
					"stylus-loader": "^1.5.1",
					webpack: "^2.6.1",
					"webpack-dev-server": "^2.4.5",
				},
				dependencies: {
					"babel-plugin-transform-es3-member-expression-literals": "latest",
					"babel-plugin-transform-es3-property-literals": "latest",
					"babel-polyfill": "latest",
					"js-cookie": "latest",
					"ua-parser-js": "latest",
				},
			};
		},
		function (e, t, n) {
			var r;
			!(function (o, i) {
				"use strict";

				var a = "model";
				var s = "name";
				var u = "type";
				var c = "vendor";
				var l = "version";
				var f = "mobile";
				var d = "tablet";
				var p = {
					extend: function extend(e, t) {
						var n = {};

						for (var _r27 in e) {
							t[_r27] && t[_r27].length % 2 == 0
								? (n[_r27] = t[_r27].concat(e[_r27]))
								: (n[_r27] = e[_r27]);
						}

						return n;
					},
					has: function has(e, t) {
						return (
							typeof e === "string" &&
							t.toLowerCase().indexOf(e.toLowerCase()) !== -1
						);
					},
					lowerize: function lowerize(e) {
						return e.toLowerCase();
					},
					major: function major(e) {
						return typeof e === "string"
							? e.replace(/[^\d\.]/g, "").split(".")[0]
							: void 0;
					},
					trim: function trim(e) {
						return e.replace(/^[\s\uFEFF\u00A0]+|[\s\uFEFF\u00A0]+$/g, "");
					},
				};
				var b = {
					rgx: function rgx(e, t) {
						for (var n, r, o, i, a, s, u = 0; u < t.length && !a; ) {
							var _c = t[u];
							var _l2 = t[u + 1];

							for (n = r = 0; n < _c.length && !a; ) {
								if ((a = _c[n++].exec(e)))
									for (o = 0; o < _l2.length; o++) {
										(s = a[++r]),
											(i = _l2[o]),
											_typeof(i) === "object" && i.length > 0
												? i.length == 2
													? typeof i[1] === "function"
														? (this[i[0]] = i[1].call(this, s))
														: (this[i[0]] = i[1])
													: i.length == 3
													? typeof i[1] !== "function" ||
														(i[1].exec && i[1].test)
														? (this[i[0]] = s ? s.replace(i[1], i[2]) : void 0)
														: (this[i[0]] = s
																? i[1].call(this, s, i[2])
																: void 0)
													: i.length == 4 &&
														(this[i[0]] = s
															? i[3].call(this, s.replace(i[1], i[2]))
															: void 0)
												: (this[i] = s || void 0);
									}
							}

							u += 2;
						}
					},
					str: function str(e, t) {
						for (var _n29 in t) {
							if (_typeof(t[_n29]) === "object" && t[_n29].length > 0) {
								for (var _r28 = 0; _r28 < t[_n29].length; _r28++) {
									if (p.has(t[_n29][_r28], e))
										return _n29 === "?" ? void 0 : _n29;
								}
							} else if (p.has(t[_n29], e)) return _n29 === "?" ? void 0 : _n29;
						}

						return e;
					},
				};
				var y = {
					browser: {
						oldsafari: {
							version: {
								"1.0": "/8",
								1.2: "/1",
								1.3: "/3",
								"2.0": "/412",
								"2.0.2": "/416",
								"2.0.3": "/417",
								"2.0.4": "/419",
								"?": "/",
							},
						},
					},
					device: {
						amazon: {
							model: {
								"Fire Phone": ["SD", "KF"],
							},
						},
						sprint: {
							model: {
								"Evo Shift 4G": "7373KT",
							},
							vendor: {
								HTC: "APA",
								Sprint: "Sprint",
							},
						},
					},
					os: {
						windows: {
							version: {
								ME: "4.90",
								"NT 3.11": "NT3.51",
								"NT 4.0": "NT4.0",
								2000: "NT 5.0",
								XP: ["NT 5.1", "NT 5.2"],
								Vista: "NT 6.0",
								7: "NT 6.1",
								8: "NT 6.2",
								8.1: "NT 6.3",
								10: ["NT 6.4", "NT 10.0"],
								RT: "ARM",
							},
						},
					},
				};
				var h = {
					browser: [
						[
							/(opera\smini)\/([\w\.-]+)/i,
							/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,
							/(opera).+version\/([\w\.]+)/i,
							/(opera)[\/\s]+([\w\.]+)/i,
						],
						[s, l],
						[/(opios)[\/\s]+([\w\.]+)/i],
						[[s, "Opera Mini"], l],
						[/\s(opr)\/([\w\.]+)/i],
						[[s, "Opera"], l],
						[
							/(kindle)\/([\w\.]+)/i,
							/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
							/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
							/(?:ms|\()(ie)\s([\w\.]+)/i,
							/(rekonq)\/([\w\.]+)*/i,
							/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i,
						],
						[s, l],
						[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],
						[[s, "IE"], l],
						[/(edge)\/((\d+)?[\w\.]+)/i],
						[s, l],
						[/(yabrowser)\/([\w\.]+)/i],
						[[s, "Yandex"], l],
						[/(puffin)\/([\w\.]+)/i],
						[[s, "Puffin"], l],
						[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],
						[[s, "UCBrowser"], l],
						[/(comodo_dragon)\/([\w\.]+)/i],
						[[s, /_/g, " "], l],
						[/(micromessenger)\/([\w\.]+)/i],
						[[s, "WeChat"], l],
						[/(QQ)\/([\d\.]+)/i],
						[s, l],
						[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],
						[s, l],
						[/xiaomi\/miuibrowser\/([\w\.]+)/i],
						[l, [s, "MIUI Browser"]],
						[/;fbav\/([\w\.]+);/i],
						[l, [s, "Facebook"]],
						[/headlesschrome(?:\/([\w\.]+)|\s)/i],
						[l, [s, "Chrome Headless"]],
						[/\swv\).+(chrome)\/([\w\.]+)/i],
						[[s, /(.+)/, "$1 WebView"], l],
						[/((?:oculus|samsung)browser)\/([\w\.]+)/i],
						[[s, /(.+(?:g|us))(.+)/, "$1 $2"], l],
						[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],
						[l, [s, "Android Browser"]],
						[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],
						[s, l],
						[/(dolfin)\/([\w\.]+)/i],
						[[s, "Dolphin"], l],
						[/((?:android.+)crmo|crios)\/([\w\.]+)/i],
						[[s, "Chrome"], l],
						[/(coast)\/([\w\.]+)/i],
						[[s, "Opera Coast"], l],
						[/fxios\/([\w\.-]+)/i],
						[l, [s, "Firefox"]],
						[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],
						[l, [s, "Mobile Safari"]],
						[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],
						[l, s],
						[
							/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i,
						],
						[[s, "GSA"], l],
						[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],
						[s, [l, b.str, y.browser.oldsafari.version]],
						[/(konqueror)\/([\w\.]+)/i, /(webkit|khtml)\/([\w\.]+)/i],
						[s, l],
						[/(navigator|netscape)\/([\w\.-]+)/i],
						[[s, "Netscape"], l],
						[
							/(swiftfox)/i,
							/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
							/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
							/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,
							/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
							/(links)\s\(([\w\.]+)/i,
							/(gobrowser)\/?([\w\.]+)*/i,
							/(ice\s?browser)\/v?([\w\._]+)/i,
							/(mosaic)[\/\s]([\w\.]+)/i,
						],
						[s, l],
					],
					cpu: [
						[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],
						[["architecture", "amd64"]],
						[/(ia32(?=;))/i],
						[["architecture", p.lowerize]],
						[/((?:i[346]|x)86)[;\)]/i],
						[["architecture", "ia32"]],
						[/windows\s(ce|mobile);\sppc;/i],
						[["architecture", "arm"]],
						[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],
						[["architecture", /ower/, "", p.lowerize]],
						[/(sun4\w)[;\)]/i],
						[["architecture", "sparc"]],
						[
							/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i,
						],
						[["architecture", p.lowerize]],
					],
					device: [
						[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],
						[a, c, [u, d]],
						[/applecoremedia\/[\w\.]+ \((ipad)/],
						[a, [c, "Apple"], [u, d]],
						[/(apple\s{0,1}tv)/i],
						[
							[a, "Apple TV"],
							[c, "Apple"],
						],
						[
							/(archos)\s(gamepad2?)/i,
							/(hp).+(touchpad)/i,
							/(hp).+(tablet)/i,
							/(kindle)\/([\w\.]+)/i,
							/\s(nook)[\w\s]+build\/(\w+)/i,
							/(dell)\s(strea[kpr\s\d]*[\dko])/i,
						],
						[c, a, [u, d]],
						[/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i],
						[a, [c, "Amazon"], [u, d]],
						[/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i],
						[
							[a, b.str, y.device.amazon.model],
							[c, "Amazon"],
							[u, f],
						],
						[/\((ip[honed|\s\w*]+);.+(apple)/i],
						[a, c, [u, f]],
						[/\((ip[honed|\s\w*]+);/i],
						[a, [c, "Apple"], [u, f]],
						[
							/(blackberry)[\s-]?(\w+)/i,
							/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
							/(hp)\s([\w\s]+\w)/i,
							/(asus)-?(\w+)/i,
						],
						[c, a, [u, f]],
						[/\(bb10;\s(\w+)/i],
						[a, [c, "BlackBerry"], [u, f]],
						[
							/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i,
						],
						[a, [c, "Asus"], [u, d]],
						[/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i],
						[
							[c, "Sony"],
							[a, "Xperia Tablet"],
							[u, d],
						],
						[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],
						[a, [c, "Sony"], [u, f]],
						[/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i],
						[c, a, [u, "console"]],
						[/android.+;\s(shield)\sbuild/i],
						[a, [c, "Nvidia"], [u, "console"]],
						[/(playstation\s[34portablevi]+)/i],
						[a, [c, "Sony"], [u, "console"]],
						[/(sprint\s(\w+))/i],
						[
							[c, b.str, y.device.sprint.vendor],
							[a, b.str, y.device.sprint.model],
							[u, f],
						],
						[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],
						[c, a, [u, d]],
						[
							/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,
							/(zte)-(\w+)*/i,
							/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i,
						],
						[c, [a, /_/g, " "], [u, f]],
						[/(nexus\s9)/i],
						[a, [c, "HTC"], [u, d]],
						[/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i],
						[a, [c, "Huawei"], [u, f]],
						[/(microsoft);\s(lumia[\s\w]+)/i],
						[c, a, [u, f]],
						[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],
						[a, [c, "Microsoft"], [u, "console"]],
						[/(kin\.[onetw]{3})/i],
						[
							[a, /\./g, " "],
							[c, "Microsoft"],
							[u, f],
						],
						[
							/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
							/mot[\s-]?(\w+)*/i,
							/(XT\d{3,4}) build\//i,
							/(nexus\s6)/i,
						],
						[a, [c, "Motorola"], [u, f]],
						[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],
						[a, [c, "Motorola"], [u, d]],
						[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],
						[
							[c, p.trim],
							[a, p.trim],
							[u, "smarttv"],
						],
						[/hbbtv.+maple;(\d+)/i],
						[
							[a, /^/, "SmartTV"],
							[c, "Samsung"],
							[u, "smarttv"],
						],
						[/\(dtv[\);].+(aquos)/i],
						[a, [c, "Sharp"], [u, "smarttv"]],
						[
							/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
							/((SM-T\w+))/i,
						],
						[[c, "Samsung"], a, [u, d]],
						[/smart-tv.+(samsung)/i],
						[c, [u, "smarttv"], a],
						[
							/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
							/(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
							/sec-((sgh\w+))/i,
						],
						[[c, "Samsung"], a, [u, f]],
						[/sie-(\w+)*/i],
						[a, [c, "Siemens"], [u, f]],
						[/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]+)*/i],
						[[c, "Nokia"], a, [u, f]],
						[/android\s3\.[\s\w;-]{10}(a\d{3})/i],
						[a, [c, "Acer"], [u, d]],
						[/android.+([vl]k\-?\d{3})\s+build/i],
						[a, [c, "LG"], [u, d]],
						[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],
						[[c, "LG"], a, [u, d]],
						[/(lg) netcast\.tv/i],
						[c, a, [u, "smarttv"]],
						[
							/(nexus\s[45])/i,
							/lg[e;\s\/-]+(\w+)*/i,
							/android.+lg(\-?[\d\w]+)\s+build/i,
						],
						[a, [c, "LG"], [u, f]],
						[/android.+(ideatab[a-z0-9\-\s]+)/i],
						[a, [c, "Lenovo"], [u, d]],
						[/linux;.+((jolla));/i],
						[c, a, [u, f]],
						[/((pebble))app\/[\d\.]+\s/i],
						[c, a, [u, "wearable"]],
						[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],
						[c, a, [u, f]],
						[/crkey/i],
						[
							[a, "Chromecast"],
							[c, "Google"],
						],
						[/android.+;\s(glass)\s\d/i],
						[a, [c, "Google"], [u, "wearable"]],
						[/android.+;\s(pixel c)\s/i],
						[a, [c, "Google"], [u, d]],
						[/android.+;\s(pixel xl|pixel)\s/i],
						[a, [c, "Google"], [u, f]],
						[
							/android.+(\w+)\s+build\/hm\1/i,
							/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,
							/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,
							/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i,
						],
						[
							[a, /_/g, " "],
							[c, "Xiaomi"],
							[u, f],
						],
						[/android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i],
						[
							[a, /_/g, " "],
							[c, "Xiaomi"],
							[u, d],
						],
						[/android.+;\s(m[1-5]\snote)\sbuild/i],
						[a, [c, "Meizu"], [u, d]],
						[/android.+a000(1)\s+build/i],
						[a, [c, "OnePlus"], [u, f]],
						[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],
						[a, [c, "RCA"], [u, d]],
						[/android.+[;\/]\s*(Venue[\d\s]*)\s+build/i],
						[a, [c, "Dell"], [u, d]],
						[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],
						[a, [c, "Verizon"], [u, d]],
						[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],
						[[c, "Barnes & Noble"], a, [u, d]],
						[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],
						[a, [c, "NuVision"], [u, d]],
						[/android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i],
						[[c, "ZTE"], a, [u, d]],
						[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],
						[a, [c, "Swiss"], [u, f]],
						[/android.+[;\/]\s*(zur\d{3})\s+build/i],
						[a, [c, "Swiss"], [u, d]],
						[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],
						[a, [c, "Zeki"], [u, d]],
						[
							/(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,
							/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i,
						],
						[[c, "Dragon Touch"], a, [u, d]],
						[/android.+[;\/]\s*(NS-?.+)\s+build/i],
						[a, [c, "Insignia"], [u, d]],
						[/android.+[;\/]\s*((NX|Next)-?.+)\s+build/i],
						[a, [c, "NextBook"], [u, d]],
						[
							/android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i,
						],
						[[c, "Voice"], a, [u, f]],
						[/android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i],
						[[c, "LvTel"], a, [u, f]],
						[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],
						[a, [c, "Envizen"], [u, d]],
						[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i],
						[c, a, [u, d]],
						[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],
						[a, [c, "MachSpeed"], [u, d]],
						[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],
						[c, a, [u, d]],
						[/android.+[;\/]\s*TU_(1491)\s+build/i],
						[a, [c, "Rotor"], [u, d]],
						[/android.+(KS(.+))\s+build/i],
						[a, [c, "Amazon"], [u, d]],
						[/android.+(Gigaset)[\s\-]+(Q.+)\s+build/i],
						[c, a, [u, d]],
						[/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i],
						[[u, p.lowerize], c, a],
						[/(android.+)[;\/].+build/i],
						[a, [c, "Generic"]],
					],
					engine: [
						[/windows.+\sedge\/([\w\.]+)/i],
						[l, [s, "EdgeHTML"]],
						[
							/(presto)\/([\w\.]+)/i,
							/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,
							/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,
							/(icab)[\/\s]([23]\.[\d\.]+)/i,
						],
						[s, l],
						[/rv\:([\w\.]+).*(gecko)/i],
						[l, s],
					],
					os: [
						[/microsoft\s(windows)\s(vista|xp)/i],
						[s, l],
						[
							/(windows)\snt\s6\.2;\s(arm)/i,
							/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,
							/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i,
						],
						[s, [l, b.str, y.os.windows.version]],
						[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],
						[
							[s, "Windows"],
							[l, b.str, y.os.windows.version],
						],
						[/\((bb)(10);/i],
						[[s, "BlackBerry"], l],
						[
							/(blackberry)\w*\/?([\w\.]+)*/i,
							/(tizen)[\/\s]([\w\.]+)/i,
							/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
							/linux;.+(sailfish);/i,
						],
						[s, l],
						[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],
						[[s, "Symbian"], l],
						[/\((series40);/i],
						[s],
						[/mozilla.+\(mobile;.+gecko.+firefox/i],
						[[s, "Firefox OS"], l],
						[
							/(nintendo|playstation)\s([wids34portablevu]+)/i,
							/(mint)[\/\s\(]?(\w+)*/i,
							/(mageia|vectorlinux)[;\s]/i,
							/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
							/(hurd|linux)\s?([\w\.]+)*/i,
							/(gnu)\s?([\w\.]+)*/i,
						],
						[s, l],
						[/(cros)\s[\w]+\s([\w\.]+\w)/i],
						[[s, "Chromium OS"], l],
						[/(sunos)\s?([\w\.]+\d)*/i],
						[[s, "Solaris"], l],
						[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],
						[s, l],
						[/(haiku)\s(\w+)/i],
						[s, l],
						[
							/cfnetwork\/.+darwin/i,
							/ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i,
						],
						[
							[l, /_/g, "."],
							[s, "iOS"],
						],
						[
							/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
							/(macintosh|mac(?=_powerpc)\s)/i,
						],
						[
							[s, "Mac OS"],
							[l, /_/g, "."],
						],
						[
							/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,
							/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,
							/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
							/(unix)\s?([\w\.]+)*/i,
						],
						[s, l],
					],
				};

				var w = function w(e, t) {
					if (
						(_typeof(e) === "object" && ((t = e), (e = void 0)),
						!(this instanceof w))
					)
						return new w(e, t).getResult();
					var n =
						e ||
						(o && o.navigator && o.navigator.userAgent
							? o.navigator.userAgent
							: "");
					var r = t ? p.extend(h, t) : h;
					return (
						(this.getBrowser = function () {
							var e = {
								name: void 0,
								version: void 0,
							};
							return (
								b.rgx.call(e, n, r.browser), (e.major = p.major(e.version)), e
							);
						}),
						(this.getCPU = function () {
							var e = {
								architecture: void 0,
							};
							return b.rgx.call(e, n, r.cpu), e;
						}),
						(this.getDevice = function () {
							var e = {
								vendor: void 0,
								model: void 0,
								type: void 0,
							};
							return b.rgx.call(e, n, r.device), e;
						}),
						(this.getEngine = function () {
							var e = {
								name: void 0,
								version: void 0,
							};
							return b.rgx.call(e, n, r.engine), e;
						}),
						(this.getOS = function () {
							var e = {
								name: void 0,
								version: void 0,
							};
							return b.rgx.call(e, n, r.os), e;
						}),
						(this.getResult = function () {
							return {
								ua: this.getUA(),
								browser: this.getBrowser(),
								engine: this.getEngine(),
								os: this.getOS(),
								device: this.getDevice(),
								cpu: this.getCPU(),
							};
						}),
						(this.getUA = function () {
							return n;
						}),
						(this.setUA = function (e) {
							return (n = e), this;
						}),
						this
					);
				};

				(w.VERSION = "0.7.17"),
					(w.BROWSER = {
						NAME: s,
						MAJOR: "major",
						VERSION: l,
					}),
					(w.CPU = {
						ARCHITECTURE: "architecture",
					}),
					(w.DEVICE = {
						MODEL: a,
						VENDOR: c,
						TYPE: u,
						CONSOLE: "console",
						MOBILE: f,
						SMARTTV: "smarttv",
						TABLET: d,
						WEARABLE: "wearable",
						EMBEDDED: "embedded",
					}),
					(w.ENGINE = {
						NAME: s,
						VERSION: l,
					}),
					(w.OS = {
						NAME: s,
						VERSION: l,
					}),
					void 0 !== t
						? (void 0 !== e && e.exports && (t = e.exports = w),
							(t.UAParser = w))
						: n(41)
						? void 0 !==
								(r = function () {
									return w;
								}.call(t, n, t, e)) && (e.exports = r)
						: o && (o.UAParser = w);
				var v = o && (o.jQuery || o.Zepto);

				if (void 0 !== v) {
					var m = new w();
					(v.ua = m.getResult()),
						(v.ua.get = function () {
							return m.getUA();
						}),
						(v.ua.set = function (e) {
							m.setUA(e);
							var t = m.getResult();

							for (var _n30 in t) {
								v.ua[_n30] = t[_n30];
							}
						});
				}
			})(
				(typeof window === "undefined" ? "undefined" : _typeof(window)) ===
					"object"
					? window
					: this
			);
		},
		function (e, t) {
			(function (t) {
				e.exports = t;
			}.call(t, {}));
		},
		function (e, t, n) {
			e.exports = n(13);
		},
	]);
});
